import React, { useState, useEffect } from 'react'
import { errorMap } from './BaseComponent'
import Multiselect from 'multiselect-react-dropdown';

export default function MultiselectDisabledComponent({ API, select, selected, endpoint, table }) {
    const [options, setOptions] = useState([])
  
    // const getOptions = () => {
    //   let url = API+endpoint
    //   const params = {
    //     "limit": 100,
    //     "offset": 0,
    //     archived: false
    //   }
  
    //   fetch(url, {
    //     method: "POST",
    //     headers: {
    //         "Content-Type": "application/json; charset=utf-8",
    //         "Authorization": "Bearer " + sessionStorage.getItem('token')
    //       },
    //       body: JSON.stringify(params)
    //     })
    //   .then((response) => {
    //       return response.json()
    //   })
    //   .then((result) => {
    //     if (result.status.success) {
    //         let tempArray = []
    //         for (let i = 0; i < result.data[table].length; i++) {
    //             const element = result.data[table][i];
    //             tempArray.push(element.ident)
    //         }
    //       setOptions(tempArray)
    //     } else {
    //       window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : errorMap(result.data?.error?.ident || result.data?.error) }}), true);
    //     }
    //   }, (error) => {
    //     console.log(error)
    //   })
    // }
  
    useEffect(() => {
      // getOptions()
      // eslint-disable-next-line
    }, [])
    
    return (
      <Multiselect
        options={options}
        selectedValues={selected}
        onSelect={select}
        onRemove={select}
        isObject={false}
        disable
      />
    )
  }